import clsx from 'clsx'
import { FieldError, Label } from 'components/core-v2'
import { getFieldIds } from 'components/core-v2/molecules/fields/__utils__/getFieldIds'
import {
  NumericalDisplay,
  NumericalDisplayProps
} from 'components/core-v2/molecules/fields/numerical-display-field'
import { useFormContext } from 'react-hook-form'

import classes from './currency-field.module.scss'

export interface CurrencyFieldProps extends NumericalDisplayProps {
  label?: string

  symbol: string
}

export const CurrencyField = ({
  className,
  decimalPlaces = 2,
  id,
  label,
  symbol,
  ...rest
}: CurrencyFieldProps) => {
  const {
    formState: { errors }
  } = useFormContext()
  const { errorId } = getFieldIds(id)
  const error = errors[id]?.message
  const hasError = Boolean(error)
  return (
    <>
      {label && (
        <Label className={classes.label} htmlFor={id}>
          {label}
        </Label>
      )}
      <div className={clsx(classes.root, className)}>
        <div className={clsx(classes.symbol)}>
          <span>{symbol}</span>
        </div>
        <NumericalDisplay decimalPlaces={decimalPlaces} hasError={hasError} id={id} {...rest} />
      </div>
      {error && <FieldError id={errorId}>{String(error)}</FieldError>}
    </>
  )
}
